import validate from 'validate.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const validateSoundForm = ({
  ambient_noise_description = ''
}) => {
  if ('' !== ambient_noise_description) {
    return {
      ambient_noise_description: validate.single(ambient_noise_description,
        {
          length: {
            minimum: 15,
            tooShort: (<FormattedMessage id="hosting.validate_rules_form.min_character_message" defaultMessage="Enter at least 15 characters" />)
          }
        })
    };
  }
};

export default validateSoundForm;
